/// <amd-module name="SuiteCommerce.CookieConsent.CookiesHandler"/>
define("SuiteCommerce.CookieConsent.CookiesHandler", ["require", "exports", "SuiteCommerce.CookieConsent.Common.Cookies", "underscore"], function (require, exports, Cookies_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var COOKIE_CONSENT_COOKIES_NAME = 'trackingConsentCookie';
    var COOKIE_CONSENT_COOKIES_EXPIRATION_DAYS = 90;
    var container = null;
    var CookiesHandler = /** @class */ (function () {
        function CookiesHandler() {
        }
        CookiesHandler.initCookiesHandler = function (componentContainer) {
            container = componentContainer;
            this.updateCookies();
        };
        CookiesHandler.setCookies = function (cookiesSettings) {
            var _this = this;
            var deferred = jQuery.Deferred();
            if (cookiesSettings) {
                var userProfile_1 = container.getComponent('UserProfile');
                userProfile_1
                    .getUserProfile()
                    .then(function (profile) {
                    if (profile.isloggedin) {
                        _this.saveCookiesInTheCustomerRecord(userProfile_1, cookiesSettings)
                            .done(function () { return deferred.resolve(); })
                            .fail(function () { return deferred.reject(); });
                    }
                    else {
                        _this.saveCookiesInTheBrowser(cookiesSettings)
                            .done(function () { return deferred.resolve(); })
                            .fail(function () { return deferred.reject(); });
                    }
                })
                    .catch(function () {
                    deferred.reject();
                });
            }
            return deferred;
        };
        CookiesHandler.getCookies = function () {
            var cookies = Cookies_1.default.getInstance();
            return cookies.get(COOKIE_CONSENT_COOKIES_NAME);
        };
        CookiesHandler.getDecodedCookies = function () {
            return this.decode(this.getCookies());
        };
        CookiesHandler.updateCookies = function () {
            var _this = this;
            if (this.getDecodedCookies()) {
                var userProfile_2 = container.getComponent('UserProfile');
                userProfile_2.getUserProfile().then(function (profile) {
                    if (profile.isloggedin) {
                        userProfile_2
                            .getCookieOptions()
                            .then(function (cookieOptions) {
                            var customerCookieTimestamp = (cookieOptions === null || cookieOptions === void 0 ? void 0 : cookieOptions.consentLastUpdate) || 0;
                            var previousCookies = _this.getDecodedCookies();
                            if (customerCookieTimestamp >= previousCookies.timestamp) {
                                var customerCookieCookieSettings = _.omit(cookieOptions, 'consentLastUpdate');
                                _this.saveCookiesInTheBrowser(customerCookieCookieSettings, customerCookieTimestamp);
                            }
                            else if (customerCookieTimestamp < previousCookies.timestamp) {
                                _this.saveCookiesInTheCustomerRecord(userProfile_2, previousCookies.consentSettings);
                            }
                        });
                    }
                });
            }
        };
        CookiesHandler.saveCookiesInTheCustomerRecord = function (userProfile, cookiesSettings) {
            var _this = this;
            var deferred = jQuery.Deferred();
            if (userProfile && cookiesSettings) {
                userProfile
                    .setCookieOptions(cookiesSettings)
                    .then(function () {
                    userProfile
                        .getCookieOptions()
                        .then(function (cookieOptions) {
                        var timestamp = cookieOptions.consentLastUpdate;
                        _this.saveCookiesInTheBrowser(cookiesSettings, timestamp)
                            .done(function () { return deferred.resolve(); })
                            .fail(function () { return deferred.reject(); });
                    });
                })
                    .catch(function () {
                    _this.saveCookiesInTheBrowser(cookiesSettings)
                        .done(function () { return deferred.resolve(); })
                        .fail(function () { return deferred.reject(); });
                });
            }
            return deferred;
        };
        CookiesHandler.saveCookiesInTheBrowser = function (cookiesSettings, timestamp) {
            var deferred = jQuery.Deferred();
            var cookies = Cookies_1.default.getInstance();
            var cookieConsent = this.generateCookieConsentObject(cookiesSettings, timestamp);
            cookies.set(COOKIE_CONSENT_COOKIES_NAME, this.encode(cookieConsent), {
                expires: COOKIE_CONSENT_COOKIES_EXPIRATION_DAYS
            });
            return deferred.resolve();
        };
        CookiesHandler.generateCookieConsentObject = function (cookiesSettings, timestamp) {
            if (timestamp === void 0) { timestamp = Date.now(); }
            var previousCookies = this.getDecodedCookies();
            return {
                id: previousCookies
                    ? previousCookies.id
                    : this.generateCookieId(timestamp),
                timestamp: timestamp,
                consentSettings: cookiesSettings
            };
        };
        CookiesHandler.generateCookieId = function (timestamp) {
            var userAgent = navigator.userAgent;
            return this.encode({ timestamp: timestamp, userAgent: userAgent });
        };
        CookiesHandler.encode = function (data) {
            return btoa(JSON.stringify(data));
        };
        CookiesHandler.decode = function (cookieData) {
            if (cookieData) {
                return JSON.parse(atob(cookieData));
            }
            return null;
        };
        return CookiesHandler;
    }());
    exports.CookiesHandler = CookiesHandler;
});
